import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Flex, Button, Card } from 'antd';
import styled from 'styled-components';
import Icon from 'components/Shared/Common/Icon';

const FileAudioContainer = styled.div`
    .card {
        width: fit-content;
    }
    audio {
        width: 350px;
    }
`;

const FileAudioTemplate = ({ src, title, onDownload }) => (
    <FileAudioContainer>
        <Card
            size="small"
            title={title}
            className="card"
            extra={
                <Button
                    shape="circle"
                    type="text"
                    size={'middle'}
                    icon={<Icon iconName={'DownloadCloud'} />}
                    onClick={onDownload}
                />
            }
        >
            <Flex gap="small">
                <Flex vertical>
                    <audio src={src} controls title={title} controlsList="nodownload" />
                </Flex>
            </Flex>
        </Card>
    </FileAudioContainer>
);

FileAudioTemplate.propTypes = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onDownload: PropTypes.func.isRequired
};

export default memo(FileAudioTemplate);
